import { useState, useCallback } from 'react';
import { pw9208Api, F90M } from '../../../services/pw9208Api';

export interface PW9208Names {
  employee: string;
  department: string;
  position: string;
  enterBy: string;
  supervisor: string;
  hrManager: string;
  vp: string;
  gm: string;
}

const emptyNames = (): PW9208Names => ({
  employee: '',
  department: '',
  position: '',
  enterBy: '',
  supervisor: '',
  hrManager: '',
  vp: '',
  gm: '',
});

export function usePW9208Lookup() {
  const [names, setNames] = useState<PW9208Names>(emptyNames());

  const resolveSingleName = useCallback(
    async (nameKey: keyof PW9208Names, lookupType: string, code: string) => {
      const name = await pw9208Api.lookupName(lookupType, code);
      setNames(prev => ({ ...prev, [nameKey]: name }));
    },
    []
  );

  const resolveAllNames = useCallback(async (record: Partial<F90M>) => {
    const [emp, dept, pos, enterBy] = await Promise.all([
      pw9208Api.lookupName('employee', record.f90m_11 || ''),
      pw9208Api.lookupName('department', record.f90m_21 || ''),
      pw9208Api.lookupName('position', record.f90m_22 || ''),
      pw9208Api.lookupName('employee', record.f90m_20 || ''),
    ]);
    setNames({
      employee: emp,
      department: dept,
      position: pos,
      enterBy,
      supervisor: '',
      hrManager: '',
      vp: '',
      gm: '',
    });
  }, []);

  const clearNames = useCallback(() => {
    setNames(emptyNames());
  }, []);

  return { names, resolveSingleName, resolveAllNames, clearNames };
}
